import axiosInstance from "@/plugins/axios";

export const axiosBaseQuery =
    ({ baseUrl } = { baseUrl: '' }) =>
        async (props) => {
            let { url, method, body, params, headers } = props;

            try {
                const result = await axiosInstance({
                    url: baseUrl + url,
                    method,
                    data: body,
                    params,
                    headers,
                })

                return { data: result }
            } catch (axiosError) {
                const err = axiosError
                return {
                    error: {
                        status: err.response?.status,
                        data: err.response?.data || err.message,
                    },
                }
            }
        }